import "./ServicesPage.css";
import React from "react";
import PageHeader from "../../components/pageheader/pageheader";
import Services from "../../components/services/services";
import CtaTab from "../../components/ctatab/ctatab";
function ServicesPage() {
  return (
    <>
      <PageHeader title="Services" />
      <Services />
      <CtaTab />
    </>
  );
}

export default ServicesPage;
